<script>
import Rellax from "rellax";
export default {
  name: "Event",
  mounted() {
    this.$nextTick(() => {
      const { cover } = this.$refs;
      new Rellax(cover, { speed: -3, center: true });
    });
  }
};
</script>

<script>
export default {
  name: "Event"
};
</script>
<style lang="stylus" scoped>
@import "Event"
</style>
